import React, { useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from '@ygtechnologies/bygr-frontend-component-library';
import { Trans } from '@lingui/react/macro';
import { triggerHandler } from '@ygtechnologies/rubus-frontend-utilities';
import { requestNewChangeRequestOffers } from '@/services/change-requests';
import { Button, ButtonBar } from '@ygtechnologies/rubus-ui';
import Banner from '@/components/Banner';

interface ChangeRequestRequestNewOffersDialogProps {
    changeRequestId: number;
    show: boolean;
    onClose(): void;
    onSave(): void;
}

const ChangeRequestRequestNewOffersDialog: React.FC<ChangeRequestRequestNewOffersDialogProps> = ({
    show,
    onClose,
    onSave,
    changeRequestId,
}) => {
    const [sending, setSending] = useState(false);

    const handleSaveClick = async () => {
        setSending(true);

        try {
            await requestNewChangeRequestOffers(changeRequestId);
            triggerHandler(onSave);
            triggerHandler(onClose);
        } finally {
            setSending(false);
        }
    };

    const handleCancelClick = () => {
        triggerHandler(onClose);
    };

    return (
        <Modal isOpen={show} toggle={handleCancelClick} size="lg">
            <ModalHeader>
                <Trans>Request new offers for request #{changeRequestId}</Trans>
            </ModalHeader>
            <ModalBody>
                <Banner type="info">
                    <Trans>
                        By requesting new offers you will reset the status of the change request to ‘Awaiting offers’ and
                        enable the participants update to submit new offers.
                    </Trans>
                </Banner>
            </ModalBody>
            <ModalFooter>
                <ButtonBar margins="none">
                    <ButtonBar.Right>
                        <Button variant="tertiary" onClick={handleCancelClick} disabled={sending}>
                            <Trans>Cancel</Trans>
                        </Button>
                        <Button variant="primary" onClick={handleSaveClick} loading={sending}>
                            <Trans>Request new offers</Trans>
                        </Button>
                    </ButtonBar.Right>
                </ButtonBar>
            </ModalFooter>
        </Modal>
    );
};

export default ChangeRequestRequestNewOffersDialog;